import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconGoogle: FC<IconProps> = ({ size = 40, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.0417 20.3573C36.0417 19.0375 35.9323 18.075 35.6975 17.076H20.3267V23.0304H29.3479C29.1671 24.5092 28.1856 26.7375 26.0025 28.2352L25.9719 28.4335L30.8311 32.1231L31.1665 32.1552C34.2611 29.3581 36.0417 25.2398 36.0417 20.3573Z"
      fill="#4285F4"
    />
    <path
      d="M20.3281 36.0416C24.7468 36.0416 28.4568 34.6154 31.1678 32.1552L26.0024 28.2352C24.6199 29.1802 22.7649 29.8393 20.3281 29.8393C18.2739 29.8395 16.2713 29.1966 14.6011 28.0009C12.9309 26.8051 11.6769 25.1165 11.0151 23.1718L10.8226 23.1879L5.76951 27.0204L5.70389 27.2012C8.39597 32.441 13.926 36.0416 20.3281 36.0416Z"
      fill="#34A853"
    />
    <path
      d="M11.0166 23.1719C10.6579 22.1526 10.4721 21.0806 10.4668 20C10.4668 18.8946 10.6681 17.8257 10.9933 16.8282L10.9845 16.6138L5.8687 12.72L5.70099 12.7988C4.55736 15.0271 3.96002 17.4954 3.95828 20C3.95828 22.5842 4.59412 25.0269 5.70391 27.2013L11.0166 23.1719Z"
      fill="#FBBC05"
    />
    <path
      d="M20.3281 10.1607C23.4022 10.1607 25.4745 11.4615 26.6572 12.5494L31.2758 8.12919C28.4393 5.54503 24.7468 3.95836 20.3281 3.95836C13.9245 3.95836 8.39597 7.55898 5.70389 12.7988L10.9976 16.8282C11.6651 14.8837 12.9229 13.1961 14.5955 12.0008C16.2682 10.8056 18.2722 10.1622 20.3281 10.1607Z"
      fill="#EB4335"
    />
  </svg>
);

IconGoogle.defaultProps = defaultIconProps;
